export const PLAYBOOK_CHECKLIST_STORAGE_KEY = 'babs:pre-season-playbook:checklist'

type ChecklistState = Record<string, boolean>

function readState(storageKey: string): ChecklistState {
  if (typeof window === 'undefined') return {}

  try {
    const raw = window.localStorage.getItem(storageKey)
    if (!raw) return {}

    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object') return {}

    return Object.fromEntries(
      Object.entries(parsed).filter(
        ([, value]) => typeof value === 'boolean',
      ),
    )
  } catch {
    return {}
  }
}

function writeState(storageKey: string, state: ChecklistState) {
  if (typeof window === 'undefined') return

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(state))
  } catch {
    // Ignore quota / private-mode errors.
  }
}

export function getChecklistItem(
  itemId: string,
  storageKey = PLAYBOOK_CHECKLIST_STORAGE_KEY,
): boolean {
  return readState(storageKey)[itemId] === true
}

export function setChecklistItem(
  itemId: string,
  checked: boolean,
  storageKey = PLAYBOOK_CHECKLIST_STORAGE_KEY,
) {
  const state = readState(storageKey)

  if (checked) {
    writeState(storageKey, { ...state, [itemId]: true })
    return
  }

  const { [itemId]: _removed, ...rest } = state
  writeState(storageKey, rest)
}
